var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Formik } from "formik";
import { v4 as uuidv4 } from 'uuid';
import { Alert, Box, Button, Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { Validation } from './validation/website-validation';
import { Initialize } from './constants/initialize';
var WebsitesInfoStep = /** @class */ (function (_super) {
    __extends(WebsitesInfoStep, _super);
    function WebsitesInfoStep(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "formikRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(_this, "validation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Validation()
        });
        Object.defineProperty(_this, "init", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Initialize()
        });
        _this.state = {
            websites: _this.props.applicationFormStore.currentFormWizard.websites
        };
        return _this;
    }
    Object.defineProperty(WebsitesInfoStep.prototype, "componentDidUpdate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (a, b, c) {
            var _this = this;
            setTimeout(function () {
                var errorCount = 0;
                _this.state.websites.forEach(function (element) {
                    if (_this.formikRef[element.id]) {
                        var errors = Object.keys(_this.formikRef[element.id].errors).length;
                        errorCount += errors;
                    }
                });
                _this.props.applicationFormStore.updateWebsitesFieldsInvalid(errorCount);
            }, 20);
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "componentDidMount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            setTimeout(function () {
                var errorCount = 0;
                _this.state.websites.forEach(function (element) {
                    if (_this.formikRef[element.id]) {
                        var errors = Object.keys(_this.formikRef[element.id].errors).length;
                        errorCount += errors;
                    }
                });
                _this.props.applicationFormStore.updateWebsitesFieldsInvalid(errorCount);
            }, 20);
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var items = this.state.websites;
            return (_jsxs(Box, __assign({ sx: { paddingTop: 3 } }, { children: [_jsx(Alert, __assign({ severity: "info", sx: { marginBottom: 5 } }, { children: "TO BE ADDED LATER" })), _jsx(Grid, __assign({ container: true, spacing: 2, sx: { marginLeft: 5 } }, { children: _jsx(Button, __assign({ variant: "contained", onClick: function (e) { return _this.onAddNewWebSiteItem(); }, startIcon: _jsx(AddIcon, {}), disabled: this.isEditable() }, { children: "Add website" })) })), items.map(function (i, index) { return (_this.renderWebSiteItem(i, index)); })] })));
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "onRefHandler", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (f, id) {
            this.formikRef[id] = f;
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "renderWebSiteItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (item, index) {
            var _this = this;
            var formikProps = {
                initialValues: item,
                initialTouched: this.validation.initialTouch,
                validateOnMount: true,
                validateOnBlur: true,
                validateOnchange: true,
                validationSchema: this.validation.schema,
                enableReinitialize: true,
                onSubmit: function (formValues, _a) {
                    var setSubmitting = _a.setSubmitting;
                    return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
                        return [2 /*return*/];
                    }); });
                }
            };
            return (_jsxs(Box, __assign({ sx: { margin: 5, padding: 3, border: 1, borderColor: 'grey.500' } }, { children: [_jsx(Grid, __assign({ container: true, spacing: 2 }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Box, __assign({ display: "flex", justifyContent: "flex-end" }, { children: _jsx(Button, __assign({ variant: "outlined", startIcon: _jsx(DeleteIcon, {}), onClick: function (e) { return _this.onDelete(item.id); }, disabled: item.isMain || this.isEditable(), color: "error" }, { children: "Delete" })) })) })) })), _jsx("br", {}), _jsx(Formik, __assign({ innerRef: function (f) { return _this.onRefHandler(f, item.id); } }, formikProps, { children: function (_a) {
                            var values = _a.values, handleBlur = _a.handleBlur, errors = _a.errors, handleSubmit = _a.handleSubmit, touched = _a.touched, setFieldValue = _a.setFieldValue;
                            return (_jsx("form", __assign({ className: "fform" }, { children: _jsxs(Grid, __assign({ spacing: 2, container: true, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(TextField, { InputLabelProps: { shrink: true }, disabled: _this.isEditable(), fullWidth: true, required: true, name: 'url', label: "Url", value: values.url, onChange: function (e) { setFieldValue(e.target.name, e.target.value); _this.onChangeField(values.id, e.target.name, e.target.value); }, onBlur: handleBlur, error: touched.url && Boolean(errors.url), helperText: touched.url && errors.url }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(TextField, { InputLabelProps: { shrink: true }, disabled: _this.isEditable(), fullWidth: true, required: true, name: 'industry', label: "Industry", value: values.industry, onChange: function (e) { setFieldValue("industry", e.target.value); _this.onChangeField(values.id, e.target.name, e.target.value); }, onBlur: handleBlur, error: touched.industry && Boolean(errors.industry), helperText: touched.industry && errors.industry }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(TextField, { InputLabelProps: { shrink: true }, disabled: _this.isEditable(), fullWidth: true, required: true, name: 'description', label: "Description of Products/Services", value: values.description, onChange: function (e) { setFieldValue("description", e.target.value); _this.onChangeField(values.id, e.target.name, e.target.value); }, onBlur: handleBlur, error: touched.description && Boolean(errors.description), helperText: touched.description && errors.description }) })), _jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { disabled: _this.isEditable(), name: "isOfferMembershipArea", value: values.isOfferMembershipArea, onBlur: handleBlur, onChange: function (e) { setFieldValue("isOfferMembershipArea", e.target.checked); _this.onChangeField(values.id, e.target.name, e.target.checked); }, checked: values.isOfferMembershipArea }), label: "Does the website offer membership/subscription access area?" }), values.isOfferMembershipArea
                                                    ? _jsxs(Grid, __assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(TextField, { InputLabelProps: { shrink: true }, disabled: _this.isEditable(), fullWidth: true, required: true, name: 'testUserId', label: "User Id (test account)", value: values.testUserId, onChange: function (e) { setFieldValue("testUserId", e.target.value); _this.onChangeField(values.id, e.target.name, e.target.value); }, onBlur: handleBlur, error: touched.testUserId && Boolean(errors.testUserId), helperText: touched.testUserId && errors.testUserId }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(TextField, { InputLabelProps: { shrink: true }, disabled: _this.isEditable(), fullWidth: true, required: true, name: 'testPassword', label: "Password (test account)", value: values.testPassword, onChange: function (e) { setFieldValue("testPassword", e.target.value); _this.onChangeField(values.id, e.target.name, e.target.value); }, onBlur: handleBlur, error: touched.testPassword && Boolean(errors.testPassword), helperText: touched.testPassword && errors.testPassword }) }))] }))
                                                    : _jsx(_Fragment, {})] }))] })) })));
                        } }))] }), item.id));
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "isEditable", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.props.applicationFormStore.isAdminMode) {
                return false;
            }
            return this.props.isSubmitted;
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "onChangeField", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id, name, value) {
            var _a;
            var websites = this.state.websites;
            var index = websites.findIndex(function (x) { return x.id === id; });
            if (index !== -1) {
                var item = __assign(__assign({}, websites[index]), (_a = {}, _a[name] = value, _a));
                websites[index] = item;
                this.props.applicationFormStore.updateWebsites(websites);
                this.setState({
                    websites: websites
                });
            }
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "onAddNewWebSiteItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var newitem = this.init.emptyWebsite;
            newitem.id = uuidv4();
            newitem.isMain = false;
            var newItems = this.state.websites;
            newItems.push(newitem);
            this.props.applicationFormStore.updateWebsites(newItems);
            this.setState(__assign(__assign({}, this.state), { websites: newItems }));
        }
    });
    Object.defineProperty(WebsitesInfoStep.prototype, "onDelete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var items = this.state.websites.filter(function (x) { return x.id !== id; });
            this.props.applicationFormStore.updateWebsites(items);
            this.setState(__assign(__assign({}, this.state), { websites: items }));
        }
    });
    WebsitesInfoStep = __decorate([
        inject('applicationFormStore'),
        observer
    ], WebsitesInfoStep);
    return WebsitesInfoStep;
}(React.Component));
export default WebsitesInfoStep;
